import React from 'react';

import './footer.css';


export const Footer = () => (
  <div className="footerWrapper">
    <p>Сайт был создан компании JancaWeb &copy;</p>
    <p>Все картинки принадлежить своим ауторам, для удаление контактируйте janca.jake@gmail.com</p>
  </div>
);
